<template>
  <div class="engagement">
    <div class="engagement-info">
      <div class="social-media-right-part forMobile">
        <img
          v-motion
          src="img/netflix-min.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>

      <div class="social-media-left-part">
        <h4>Exclusive Content</h4>
        <h1>Be your own Netflix</h1>

        <li class="first-list-item">
          <p>Host videos and content exclusively for your fans.</p>
        </li>
        <li class="first-list-item">
          <p>Select which fans can view each video.</p>
        </li>
        <li class="first-list-item">
          <p>Easily upload content directly to your HelixPay console.</p>
        </li>
      </div>

      <div class="social-media-right-part forWeb">
        <img
          v-motion
          src="img/netflix-min.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.forMobile {
  display: none;
}

.engagement {
  width: 100%;
  background-color: black;
}

.engagement-info {
  width: 71rem;
  margin: auto;
  padding-top: 5rem;
  padding-bottom: 5rem;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  border-left: 2px solid #ff5f8f;
}

.social-media-left-part h4 {
  font-weight: 700;
  font-size: 1.5rem;
  padding-top: 1rem;
  padding-left: 25px;
  padding-right: 20px;
  color: white;
}

.social-media-left-part h1 {
  color: #ff5f8f;
  line-height: 1.2;
  font-size: 4rem;
  font-weight: 800;
  margin-left: -2px;
  padding-left: 1.45rem;
  border-left: 2px solid white;
}

.social-media-logos {
  width: 50%;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.social-media-logos img {
  width: 70%;
}

.social-media-left-part li {
  width: 100%;
  align-items: center;
  font-size: 1rem;
  top: -10rem;
  margin-bottom: 20px;
  margin-right: 30px;
  margin-left: 1.45rem;
  padding: 0px 20px 0px 40px;
  list-style: none;
  background-image: url('/img/check-list-cc.svg');
  background-repeat: no-repeat;
  background-position: 0% 40%;
  background-size: 1rem;
}

.social-media-left-part p {
  line-height: 1.5;
  font-weight: 500;
  color: white;
}

.social-media-right-part {
  width: 100%;
  margin: auto;
}

.social-media-right-part img {
  width: 70%;
  margin: auto;
  display: block;
}

@media only screen and (max-width: 1400px) {
  .engagement-info {
    width: 60rem;
  }
}

@media only screen and (max-width: 1050px) {
  .forMobile {
    display: block;
  }

  .forWeb {
    display: none;
  }

  .engagement-info {
    width: 40rem;
    grid-template-columns: 1fr;
  }

  .social-media-right-part img {
    width: 63%;
    margin: auto;
    display: block;
  }
}

@media only screen and (max-width: 650px) {
  .engagement-info {
    width: 90%;
    gap: 1rem;
    border-left: none;
  }

  .social-media-left-part h4 {
    font-size: 1rem;
    padding-left: 0;
    margin-left: 0;
  }

  .social-media-left-part h1 {
    font-size: 2rem;
    border-left: none;
    margin-left: 0;
    padding-left: 0;
  }

  .social-media-logos {
    margin-left: 0;
    padding-left: 0;
  }

  .social-media-right-part {
    width: 100%;
  }

  .social-media-right-part img {
    width: 90%;
  }

  .social-media-left-part li {
    margin-left: 0;
  }
}
</style>
